const BlockType = require('../../extension-support/block-type');
const ArgumentType = require('../../extension-support/argument-type')
class matrix {
    getInfo() {
    return {
        id: 'matrix',
        name: 'matrix',
        color1: '#33ccff',
        blocks: [
            

        ],
  
    };
    }
   
}



module.exports = matrix;
